import React from "react";
import { Col, Row } from "react-bootstrap";
import AnimatedSelect from "../../../shared/AnimatedSelect";
import "../../../shared/AnimatedSelect.css";

const DemographyFilters = ({ filterValues = {}, onFilterChange }) => {
  return (
      <>
        <Col className="custom_col">
          <AnimatedSelect
            value={filterValues.age || ""}
            options={[
              { label: "Select Age", value: "" },
              { label: "18-25", value: "18-25" },
              { label: "26-35", value: "26-35" },
              { label: "36-45", value: "36-45" },
              { label: "46-60", value: "46-60" },
              { label: "60+", value: "60+" }
            ]}
            onChange={(value) => onFilterChange && onFilterChange("age", value)}
          />
        </Col>
        <Col className="custom_col">
          <AnimatedSelect
            value={filterValues.gender || ""}
            options={[
              { label: "Select Gender", value: "" },
              { label: "Male", value: "Male" },
              { label: "Female", value: "Female" },
              { label: "Other", value: "Other" }
            ]}
            onChange={(value) => onFilterChange && onFilterChange("gender", value)}
          />
        </Col>
        <Col className="custom_col">
          <AnimatedSelect
            value={filterValues.education || ""}
            options={[
              { label: "Select Education", value: "" },
              { label: "High School", value: "High School" },
              { label: "Graduate", value: "Graduate" },
              { label: "Postgraduate", value: "Postgraduate" },
              { label: "Doctorate", value: "Doctorate" }
            ]}
            onChange={(value) => onFilterChange && onFilterChange("education", value)}
          />
        </Col>
      </>
  );
};

export default DemographyFilters;
